import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";

/**
 * Dialog Root Component
 * Wrapper for Radix UI Dialog Root
 */
export const Dialog = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Root>
>(({ open, onOpenChange, ...props }, ref) => {
  // Note: Radix UI Dialog Root doesn't support ref forwarding
  // If ref is needed, it should be handled differently
  return (
    <DialogPrimitive.Root
      open={open}
      onOpenChange={onOpenChange}
      {...props}
    />
  );
});

Dialog.displayName = DialogPrimitive.Root.displayName;

